module.exports = __webpack_public_path__ + "media/mgTip.0ad60278.mp4";